<template>
    <div>
        <div class="panel">
            <van-row>
                <van-col span="4">
                    <div class="item-img"><img :src="p_ticket.product_thumb" /></div>
                </van-col>
                <van-col span="14">
                    <div class="center">
                        <div class="main-name">{{p_ticket.product_name}}</div>
                        <div class="order-time">
                            <span class="label">购买日期</span>
                            <span class="val">{{moment.unix(p_ticket.create_time).format('YYYY-MM-DD HH:mm:ss')}}</span>
                        </div>
                    </div>
                </van-col>
                <van-col span="6">
                    <div class="right">
                        <div class="price">￥{{p_ticket.price}}</div>
                        <div class="status">
                            <van-tag round :type="tagType">{{p_ticket.e_ticket_status_name}}</van-tag>
                        </div>
                    </div>
                </van-col>
            </van-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TicketItem",
        props:{
            p_ticket:{
                type:Object,
                default:null,
                required:true,
            },
        },
        data(){
            return{
                moment:this.$moment,
                tagType:this.p_ticket.e_ticket_status==5?'success':'default',
            }
        },
    }
</script>

<style lang="scss" scoped>
    .panel{
        background-color: #FFFFFF;
        margin: 8px 0;
        .item-img{
            font-size:0;
            padding: 5px;
            img {
                width: 60px;
                height: 60px;
                border-radius: 50%;
            }
        }
        .center{
            text-align: left;
            padding-left: 14px;
            position: relative;
            min-height: 70px;
            .main-name{
                padding-top: 10px;
                font-size: 12px;
                color: #666666;
            }
            .order-time{
                color: #999999;
                padding-top: 4px;
                padding-left: 4px;
                .label{
                    font-size: 10px;
                }
                .val{
                    padding-left: 4px;
                    font-size: 12px;
                }
            }
        }
        .right{
            text-align: center;
            padding-top: 10px;
            .price{
                font-size: 14px;
                color: #E34928;
            }
            .status{
                margin-top: 4px;
            }
        }
    }



</style>
